/**
 * Filters module for SpmTableAPI
 *
 * This module provides:
 * - Filter types and operators definitions
 * - Utility functions for filter management
 * - Types for filter configuration and state
 */

// Operators and filter types
export {
  SpmFilterOperator,
  FILTER_OPERATORS_BY_TYPE,
  DEFAULT_OPERATOR_BY_TYPE,
  ARRAY_VALUE_OPERATORS,
  isArrayOperator,
  isRangeOperator,
} from './operators';

export type { SpmFilterType } from './operators';

// Types
export type {
  SpmFilterOption,
  SpmFilterConfig,
  SpmRelationFilterConfig,
  SpmActiveFilter,
  SpmApiFilter,
  SpmActiveSort,
  DateRangeFilterValue,
} from './types';

// Utility functions
export {
  getFilterType,
  getAvailableOperators,
  getDefaultOperator,
  isFilterEmpty,
  buildApiFilters,
  createDefaultFilter,
  resetFilter,
  isFilterModified,
  isDateRangeFilterValue,
  computeDateRangeFromInterval,
  convertDateRangeToApiValues,
} from './utils';
